export enum CourseResponsibleFilter {
  All = 0,
  SupervisorOnly = 1,
  LecturerOnly = 2,
  SupervisorOrLecturer = 3,
}
